export const NAV_LINKS = [
  { label: "Servicios", anchor: "servicios" },
  { label: "Precios", anchor: "precios-tienda" },
  { label: "El local", anchor: "local", xl: true },
  { label: "Cómo funciona", anchor: "como-funciona" },
  { label: "Opiniones", anchor: "resenas", xl: true },
  { label: "Ubicación", anchor: "ubicacion", xl: true },
  { label: "Contacto", anchor: "contacto" },
];
